import React, { PropsWithChildren } from "react";
import Modal from "@/common/ui/Modal";
import Button from "@/common/ui/Button";
import { Container } from "@/common/ui/container";
import { LightText2 } from "@/common/ui/Text";
import { motion, AnimatePresence } from "framer-motion";

interface ConfirmationDialogProps {
  message?: string;
  confirmText?: string;
  cancelText?: string;
  modalProps?: any;
  handleConfirm: () => void;
  handleCancel: () => void;
}

interface WarningModalProps extends ConfirmationDialogProps {
  title?: string;
  className?: string;
}

export const ConfirmationDialog: React.FC<ConfirmationDialogProps> = (props) => {
  const { message, confirmText, cancelText, modalProps, handleCancel, handleConfirm } = props;

  return (
    <Container.ContentBox>
      <Container.Content className="pb-4 pt-2 px-4">
        <LightText2 text={message || modalProps?.message || "You have unsaved changes. Are you sure you want to leave?"} />
      </Container.Content>
      <Container.Separator />
      <div className="flex justify-end gap-4 w-full p-4">
        <Button variant="primary" size="small" onClick={handleCancel}>
          {cancelText || modalProps?.cancelText}
        </Button>
        <Button variant="outline-danger" size="small" onClick={handleConfirm}>
          {confirmText || modalProps?.confirmText}
        </Button>
      </div>
    </Container.ContentBox>
  );
};

export const WarningModal: React.FC<WarningModalProps> = ({
  handleCancel,
  handleConfirm,
  message = "Are you sure to discard the changes?",
  confirmText = "Discard",
  cancelText = "Keep Editing",
  title = "Discard changes",
  className = "",
}) => {
  return (
    <Modal title={title} onClose={handleCancel} className={className}>
      <ConfirmationDialog message={message} confirmText={confirmText} cancelText={cancelText} handleConfirm={handleConfirm} handleCancel={handleCancel} />
    </Modal>
  );
};

export const AnimatedWarningModal: React.FC<PropsWithChildren> = ({ children }) => {
  return (
    <AnimatePresence>
      <motion.div initial={{ opacity: 0, scale: 0.95 }} animate={{ opacity: 1, scale: 1 }} exit={{ opacity: 0, scale: 0.95 }} transition={{ duration: 0.2 }}>
        {children}
      </motion.div>
    </AnimatePresence>
  );
};
